import styled from 'styled-components';

import { MedicalDeviceOrderError } from '@dreryk/egabinet-ezwm-frontend-api';

import { Anchor, appendTestableElementAttributes } from '@dreryk/react-components';

const StyledMedicalDeviceOrderDocumentVerificationErrorsList = styled.ul`
   color: ${(props) => props.theme.errorDark};
   padding: 0 0 0 12px;
   margin: 0 0 0 27px;
   list-style: decimal;
`;
StyledMedicalDeviceOrderDocumentVerificationErrorsList.displayName =
   'StyledMedicalDeviceOrderDocumentVerificationErrorsList';

type MedicalDeviceOrderDocumentVerificationErrorsListProps = {
   readonly errors: MedicalDeviceOrderError[];
};

export const MedicalDeviceOrderDocumentVerificationErrorsList = (
   props: MedicalDeviceOrderDocumentVerificationErrorsListProps
): JSX.Element => {
   return (
      <Anchor testId={'documentVerificationErrorsList'} shouldPerformScroll>
         <StyledMedicalDeviceOrderDocumentVerificationErrorsList
            {...appendTestableElementAttributes('documentVerificationErrorsList')}
         >
            {props.errors.map((error) => (
               <li key={error.code}>
                  {error.code} {error.details}
               </li>
            ))}
         </StyledMedicalDeviceOrderDocumentVerificationErrorsList>
      </Anchor>
   );
};
